<template>
  <div class="mt-4 w-full flex flex-col flex-wrap sm:flex-row">
    <template v-for="(category, index) in categories">
      <div class="w-full px-2 sm:w-1/3 flex flex-col" :key="index">
        <button
          class="categories__categories"
          :class="[selected === category ? 'bg-yellow-500' : 'bg-white']"
          @click="selectCategory(index)"
        >
          {{ category.name }}
        </button>
        <Category
          v-if="selected === category"
          :category="selected"
          @category-updated="updateCategory"
        />
      </div>
    </template>
    <div class="flex w-full sm:w-1/3 mt-4 justify-center self-start">
      <div
        @click="$router.push({ name: 'CreateCategory' })"
        class="border-2 border-gray-700 rounded-full py-5 px-8 cursor-pointer"
      >
        <fa-icon class="text-gray-700" :icon="['fas', 'plus']" size="lg" />
      </div>
    </div>
  </div>
</template>

<script>
import { allCategories } from '@/services/api/category.js'
import Category from '@/components/ui/portal/Category.vue'

export default {
  components: {
    Category
  },
  data() {
    return {
      categories: [],
      selected: null
    }
  },
  methods: {
    selectCategory(index) {
      this.selected = this.categories[index]
      setTimeout(function() {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
      }, 500)
    },
    async updateCategory(id) {
      await this.getAllCategories().then(() => {
        this.selected = this.categories.find(category => category.id === id)
      })
    },
    getAllCategories() {
      return allCategories().then(response => {
        this.categories = response.categories
        return true
      })
    }
  },
  mounted() {
    this.getAllCategories()
  }
}
</script>

<style lang="sass">
.categories
  &__categories
    transition: all .2s ease-out
    @apply w-full my-1 rounded-md text-gray-800 font-semibold shadow-md border-b-2 border-yellow-500
    &:hover
      @apply text-gray-700 border-b-8
</style>
